// extracted by mini-css-extract-plugin
export default {"formTitle":"ChangePassword_formTitle__JmV1m","form":"ChangePassword_form__hBrra","formSubmit":"ChangePassword_formSubmit__pU2cU"};